import { FC, useEffect, useState } from 'react';
import { Button } from 'antd';
import { backIcon } from 'assets';
import { useHistory, useParams } from 'react-router-dom';
import { PrivacyPolicyStyled } from './styles';

type Props = {};

const PrivacyPolicy: FC<Props> = () => {
  const history = useHistory();
  const [flag, setFlag] = useState<boolean>(true);
  const { showFlag } = useParams<{ showFlag: string }>();
  useEffect(() => {
    if (showFlag && showFlag === 'WEB') {
      setFlag(true);
    } else {
      setFlag(false);
    }
  }, [showFlag]);

  return (
    <PrivacyPolicyStyled>
      <div className="header-top"></div>
      {flag && (
        <Button
          type="text"
          className="btn-back"
          icon={<img src={backIcon} alt="back-icon" className="mr-16" />}
          onClick={history.goBack}
        >
          <span className="fs-16 fw-6">戻る</span>
        </Button>
      )}
      <div className="form-group-tiltle">
        <div className="form-col">施工管理アプリ「匠」　プライバシーポリシー</div>
      </div>
      <div className="header-group">
        <div className="header-tiltle">大 東 建 託 株 式 会 社</div>
      </div>
      <div className="header-group">
        <div className="header-tiltle">個 人 情 報 保 護 方 針</div>
      </div>
      <div className="form-group">
        <div className="form-col font-weight text-font">
          弊社は、事業活動を展開する中で、個人情報を大切に保護することが社会的使命と認識し、お預かりする個人情報を“お客様の財産そのもの”と捉え、お客様の権利利益の保護を目的として、次に個人情報保護方針を定めて公表し、個人情報の適切な取り扱いを徹底いたします。
        </div>
      </div>
      <div className="form-group">
        <div className="form-col no-font">1．個人情報の取得・利用目的について</div>
      </div>
      <div className="form-group">
        <div className="form-col-left"></div>
        <div className="form-col-right text-font">
          弊社は、お客様から個人情報を取得する場合には、その利用目的をあらかじめお知らせ又は公表して、適法かつ公正な手段により取得いたします。また弊社は、お客様の個人情報の利用目的を特定し、その目的の達成に必要な範囲内においてのみ利用します。ご本人から事前のご承諾をいただいた場合や法で定める場合を除き、公表した利用目的以外の利用はいたしません。
        </div>
      </div>
      <div className="form-group">
        <div className="form-col no-font">2．個人情報の共同利用について</div>
      </div>
      <div className="form-group">
        <div className="form-col-left"></div>
        <div className="form-col-right text-font">
          弊社はお客様の個人情報を、弊社グループ企業内において共同して利用いたします。そのため、共同して利用する個人情報の項目、共同利用者名、利用目的をあらかじめ公表し、共同利用上の責任は弊社が負います。
        </div>
      </div>
      <div className="form-group">
        <div className="form-col no-font">3．個人情報の第三者への提供について</div>
      </div>
      <div className="form-group">
        <div className="form-col-left"></div>
        <div className="form-col-right text-font">
          弊社は、お客様の個人情報の取り扱いにおいて、法で定める場合やお客様とのご契約内容の達成に必要な場合等を除き、あらかじめお客様の同意を得ることなく、お客様の個人情報を第三者へ提供いたしません。
        </div>
      </div>
      <div className="form-group">
        <div className="form-col no-font">4．個人情報の正確性・安全管理について</div>
      </div>
      <div className="form-group">
        <div className="form-col-left"></div>
        <div className="form-col-right text-font">
          弊社は、お客様の個人情報の紛失・破壊・改ざん及び漏洩等を予防すべく、組織的・人的・物理的・技術的な安全対策を講じるとともに、必要な是正措置を講じます。また、個人情報の取り扱いを外部へ委託する場合は、委託先との間で取り扱いに関する契約を結ぶなどして適切な監督を行います。
        </div>
      </div>
      <div className="form-group">
        <div className="form-col no-font">5．個人情報の開示等のご請求について</div>
      </div>
      <div className="form-group">
        <div className="form-col-left"></div>
        <div className="form-col-right text-font">
          弊社がお預かりするお客様の個人情報について、お客様から開示・訂正・利用停止・消去及び第三者への提供停止を求められた場合には、法令や社会通念上等に照らし、適切に対応いたします。
        </div>
      </div>
      <div className="form-group">
        <div className="form-col no-font">6．各種法令等の遵守</div>
      </div>
      <div className="form-group">
        <div className="form-col-left"></div>
        <div className="form-col-right text-font">
          弊社は、個人情報の保護に関する法律及びその他法令、社会的規範等を遵守いたします。
        </div>
      </div>
      <div className="form-group">
        <div className="form-col no-font">7．位置情報の取得について</div>
      </div>
      <div className="form-group">
        <div className="form-col-left"></div>
        <div className="form-col-right text-font">
          弊社は、施工管理アプリ「匠」の機能向上とサービスの質の向上のために、お客様の位置情報の取得を行うことがあります。位置情報は、アプリ内の特定の機能利用時、またはお客様がアプリの設定で位置情報の提供に同意した場合にのみ取得されます。
          取得する位置情報は、お客様がアプリを使用しているデバイスのGPS機能を通じて収集されます。この情報は、作業現場の管理、効率的なルート案内、緊急時の対応支援など、サービス提供の目的でのみ利用されます。
          お客様は、アプリの設定にて位置情報の提供を管理・拒否することができます。ただし、位置情報の提供を停止した場合、アプリの一部機能が制限されることがあります。
          弊社は、取得した位置情報をお客様の同意なく第三者に提供することはありません。また、位置情報は、特定の個人を識別する情報と結びつけて保管されることはなく、匿名化した上での分析やサービス改善の目的でのみ使用されます。
        </div>
      </div>
      <div className="form-group">
        <div className="form-col no-font"></div>
      </div>
      <div className="form-group">
        <div className="form-col-right text-font">
          位置情報に関する弊社の取り扱い方針についてご質問がある場合、またはお客様の位置情報に関する権利行使をご希望の場合は、下記の連絡先までお問い合わせください。
          <br />
          お問合せ窓口について <br />
          大東建託株式会社　お客様サービス部
          <br />
          〒108-8211　東京都港区港南二丁目１６－１　品川イーストワンタワー
          <br />
          電話番号：0120-1673-43（お客様専用フリーダイヤル）
        </div>
      </div>
      <div className="header-top"></div>
    </PrivacyPolicyStyled>
  );
};
export default PrivacyPolicy;
